import { bytesToHex } from './hex-string.utility';

export async function getDigest(subtleCrypto: SubtleCrypto, toHash: string, salt: string, encode: (value: string) => Promise<Uint8Array>) {
    const saltedValue = toHash + salt;

    const encodedSaltedValue = await encode(saltedValue);

    const digestBuffer = await subtleCrypto.digest({ name: 'SHA-256' }, encodedSaltedValue);

    return bytesToHex(new Uint8Array(digestBuffer));
}
